import Box from '@mui/material/Box'
import { styled } from '@mui/system'

const StaticMenuBox = styled(Box)`
	padding: 1.375rem 0.65rem 3.25rem 0.85rem;
	display: flex;
	flex-direction: column;
`

export { StaticMenuBox }
